import { Box, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";

import completedImage from "../../../../../assets/image/snail-verified.png";
import { Button } from "../../../../../shared/ui";

type TExportCompleteProps = {
  onShowResult: () => void;
  processedCount?: number;
  uploadedCount?: number;
};

const ExportComplete = ({
  onShowResult,
  processedCount = 0,
  uploadedCount = 0,
}: TExportCompleteProps): ReactElement => {
  const skippedCount = processedCount - uploadedCount;

  return (
    <Stack sx={styles.wrapper}>
      <Box alt="snail" component="img" src={completedImage} width={73} />
      <Typography sx={styles.title}>Upload is completed</Typography>
      <Typography sx={[styles.count, { marginTop: "8px" }]}>
        <span>{uploadedCount}</span>profiles were uploaded
      </Typography>
      {skippedCount > 0 && (
        <Typography sx={styles.count}>
          <span>{skippedCount}</span>profiles are invisible or duplicates and
          were skipped.
        </Typography>
      )}
      <Button
        className="exportComplete-button"
        onClick={onShowResult}
        variant="primary"
      >
        Show results
      </Button>
    </Stack>
  );
};

const styles = {
  count: {
    "& > span": {
      color: "var(--black)",
      fontSize: "18px",
    },
    alignItems: "center",
    color: "var(--text-grey)",
    display: "inline-flex",
    fontSize: "12px",
    fontWeight: 600,
    gap: "4px",
    lineHeight: 1.5,
  },
  title: { fontSize: "24px", fontWeight: 700, marginTop: "16px" },
  wrapper: {
    "& > .exportComplete-button": {
      marginTop: "24px",
    },
    alignItems: "center",
    padding: "34px 24px 28px",
  },
};

export default ExportComplete;
